"use strict";

var Position = function () {
  
  var open_new_tariff_on_slidepanel = function(company_id, dep_country_id, arv_country_id) {
    $.ajax({
      type: "GET",
      url: "/tariffs/lines",
      dataType: "script",
      data: {
        company_id: company_id,
        dep_country_id: dep_country_id,
        arv_country_id: arv_country_id,
        from: 'logistics_positions'
      }
    });
  };
  
  var open_new_assign_on_slidepanel = function(company_id, branch_id) {
    $.ajax({
      type: "GET",
      url: "/waybill_stocks/lines",
      dataType: "script",
      data: {
        company_id: company_id,
        branch_id: branch_id,
        from: 'logistics_positions'
      }
    });
  };

  var handleVehicleOwner = function() {
    var contract_type = $("#position_contract_type").val();
    if (contract_type == "rented")  {
      $(".rented").show();
      $(".owned").hide();
    }
    if (contract_type == "owned")  {
      $(".rented").hide();
      $(".owned").show();
    }
    if (contract_type == "unknown") {
      $(".rented").hide();
      $(".owned").hide();
    }
  }

  var selectvoyage = function() {
    var select_voyage = $("#position_select_voyage").val();
    if (select_voyage == "our_voyage")  {
      $(".our").show();
      $(".other").hide();
    }
    if (select_voyage == "other_voyage")  {
      $(".our").hide();
      $(".other").show();
    }
    if (select_voyage == "unknown")  {
      $(".our").hide();
      $(".other").hide();
    }
  }

  var place_type_change = function(place) {
    var place_type    = $('#position_' + place + '_place_type').val();
    var place_id      = $('#position_' + place + '_place_id');

    if (place_id && place_type && !['gmaps', 'customer', 'port'].includes(place_type)) {
      place_id.attr('data-place-type', place_type);
      place_id.attr('data-url', place_id.attr('data-url').replace(/=[^=&]*$/, '=' + place_type)).trigger('change');
    }

    $('.' + place + '_place').hide();

    switch (place_type) {
      case "gmaps":
        $('#' + place + 'PlaceFields').removeClass('show');
        $('[name="position[' + place +'_address]"]').prop('disabled', true);
        $('#position_' + place +'_address').prop('disabled', false);
        $('.' + place + '_' + place_type).show();
        break;
      case "customer":
        $('[name="position[' + place +'_address]"]').prop('disabled', false);
        $('#position_' + place +'_address').prop('disabled', true);
        $('.' + place + '_' + place_type).show();
        break;
      case "port":
        $('#' + place + 'PlaceFields').removeClass('show');
        $('#position_' + place +'_address').prop('disabled', true);
        $('.' + place + '_' + place_type).show();
        break;
    }
  }

  var show_driver = function(thisObject) {
    var $this = $(thisObject);
    var showDriver = $('#' + $this.attr("show-driver"));
    var hideDriver = $('#' + $this.attr("hide-driver"));
    showDriver.show();
    hideDriver.hide();
  }

  var toggleInputVisibility = function(checkbox, inputGroup) {
    if (checkbox.is(':checked')) {
      inputGroup.show();
    } else {
      inputGroup.hide();
    }
  }

  return {
    init: function () {

      $("#position_contract_type").change(function() {
        handleVehicleOwner();
      });
      handleVehicleOwner();

      $("#position_select_voyage").change(function() {
        selectvoyage();
      });
      selectvoyage();

      $(document).on("click", "#assign", function(event) {
        var company_id = $($(this).data('company-id')).val();
        var branch_id = $($(this).data('branch-id')).val();
        open_new_assign_on_slidepanel(company_id, branch_id);
      });

      $(document).on("click", "#select_tariff", function(event) {
        var company_id = $($(this).data('company-id')).val();
        var dep_country_id = $($(this).data('dep-place-id')).val();
        var arv_country_id = $($(this).data('arv-place-id')).val();
        return open_new_tariff_on_slidepanel(company_id, dep_country_id, arv_country_id);
      });

      $(document).on("change", "#position_route_id", function(event) {
        var route_id = $('#position_route_id').val();
        if (route_id != '') {
          $.ajax({
            type: "GET",
            url: "/routes/" + route_id,
            dataType: "JSON",
            success: function(data) {
              if (data != null) {
                if (data['transit_countries_count'] > 0) {
                  $("#position_route_notes").val(data['transit_countries'])
                }
              }
            }
          });
        }
      });

      $(document).on("change", "#position_dep_place_type", function() {
        place_type_change('dep');
      });
      place_type_change('dep');

      $(document).on("change", "#position_arv_place_type", function() {
        place_type_change('arv');
      });
      place_type_change('arv');

      $(document).on("click", ".show_driver", function() {
        show_driver(this);
      });


      $('#position_picked_up').click(function() {
        toggleInputVisibility($(this), $('#picked_up_input_group'));
      });
      toggleInputVisibility($('#position_picked_up'), $('#picked_up_input_group'));
      $('#position_delivered').click(function() {
        toggleInputVisibility($(this), $('#delivered_input_group'));
      });
      toggleInputVisibility($('#position_delivered'), $('#delivered_input_group'));
      toggleInputVisibility($('#position_arv_place_id'), $('.select_arv'));
      toggleInputVisibility($('#position_arv_place_id'), $('.input_arv'));
      toggleInputVisibility($('#position_dep_place_id'), $('.select_arv'));
      toggleInputVisibility($('#position_dep_place_id'), $('.input_arv'));
      //

    }
  };

}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Position;
}
$(document).ready(function () {
	Position.init();
});
